import { render, staticRenderFns } from "./RelateInvoices.vue?vue&type=template&id=58690a02"
import script from "./RelateInvoices.vue?vue&type=script&lang=js"
export * from "./RelateInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58690a02')) {
      api.createRecord('58690a02', component.options)
    } else {
      api.reload('58690a02', component.options)
    }
    module.hot.accept("./RelateInvoices.vue?vue&type=template&id=58690a02", function () {
      api.rerender('58690a02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/treasury_accounts/RelateInvoices.vue"
export default component.exports